import getCustomers from '@/api/queries/getCustomers';
import { setCustomers } from '@/redux/data/dataSlice';
import { useAppDispatch } from '@/redux/hooks';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useCustomersQueries = () => {
  const getCustomersQuery = useQuery({
    queryKey: ['customers'],
    queryFn: getCustomers,
  });

  return {
    customers: getCustomersQuery.data,
    customersLoading: getCustomersQuery.isPending,
    isSuccess: getCustomersQuery.isSuccess,
    refetch: getCustomersQuery.refetch,
  };
};

export const useCustomersSetter = () => {
  const { customers, isSuccess, refetch } = useCustomersQueries();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (customers && isSuccess) {
      dispatch(setCustomers(customers));
    }
  }, [customers, dispatch, isSuccess]);

  return {
    refetch,
  };
};

export default useCustomersQueries;
